import React from 'react';
import { Monitor, Smartphone, CreditCard, ShieldCheck, ArrowRight } from 'lucide-react';
interface HeroSectionProps {
  onNavigate?: (pageId: string) => void;
  onSectionChange?: (section: 'documentation' | 'api-reference') => void;
}
export function HeroSection({
  onNavigate,
  onSectionChange
}: HeroSectionProps) {
  return <section className="bg-gradient-to-br from-[#0B5FA5] to-[#1E73BE] w-full px-8 py-20 md:py-28 text-white relative overflow-hidden" data-id="element-186">
      {/* Background pattern */}
      <div className="absolute inset-0 opacity-10" data-id="element-187">
        <div className="absolute -top-24 -right-24 w-96 h-96 rounded-full border-[40px] border-white" data-id="element-188"></div>
        <div className="absolute top-1/2 -left-24 w-64 h-64 rounded-full border-[20px] border-white" data-id="element-189"></div>
      </div>

      <div className="max-w-6xl mx-auto flex flex-col lg:flex-row items-center justify-between gap-12 relative z-10" data-id="element-190">
        {/* Left Content */}
        <div className="flex-1 max-w-2xl" data-id="element-191">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold leading-tight mb-6 tracking-tight" data-id="element-192">
            Paysys Developer Portal
          </h1>
          <p className="text-lg md:text-xl text-blue-100 mb-10 leading-relaxed max-w-xl" data-id="element-193">
            Build powerful payment integrations with our comprehensive suite of
            APIs. Choose the solution that best fits your business needs.
          </p>
          <div className="flex flex-wrap items-center gap-4" data-id="element-194">
            <button onClick={() => onNavigate?.('getting-started')} className="px-8 py-3.5 bg-[#F5C400] hover:bg-[#e0b400] text-gray-900 font-semibold rounded-lg transition-colors shadow-lg flex items-center" data-id="element-195">
              Start Building
              <ArrowRight className="w-4 h-4 ml-2" data-id="element-196" />
            </button>
            <button onClick={() => onSectionChange?.('api-reference')} className="px-8 py-3.5 bg-white/10 hover:bg-white/20 border border-white/30 text-white font-semibold rounded-lg transition-colors backdrop-blur-sm" data-id="element-197">
              Explore APIs
            </button>
          </div>
        </div>

        {/* Right Illustration Area */}
        <div className="flex-1 relative w-full max-w-lg h-[340px] hidden md:block" data-id="element-198">
          {/* Abstract background elements */}
          <div className="absolute top-10 right-10 w-72 h-72 bg-white/10 backdrop-blur-md rounded-2xl shadow-2xl border border-white/20 transform rotate-3" data-id="element-199"></div>
          <div className="absolute top-14 right-14 w-72 h-72 bg-white rounded-2xl shadow-2xl border border-gray-100 flex flex-col p-6" data-id="element-200">
            {/* Mock UI inside the card */}
            <div className="flex items-center justify-between mb-8 border-b border-gray-100 pb-4" data-id="element-201">
              <div className="flex space-x-1.5" data-id="element-202">
                <div className="w-3 h-3 rounded-full bg-gray-200" data-id="element-203"></div>
                <div className="w-3 h-3 rounded-full bg-gray-200" data-id="element-204"></div>
                <div className="w-3 h-3 rounded-full bg-gray-200" data-id="element-205"></div>
              </div>
              <ShieldCheck className="w-5 h-5 text-[#0B5FA5]" data-id="element-206" />
            </div>
            <div className="space-y-4" data-id="element-207">
              <div className="h-3 bg-gray-100 rounded-full w-3/4" data-id="element-208"></div>
              <div className="h-3 bg-gray-100 rounded-full w-1/2" data-id="element-209"></div>
              <div className="h-10 bg-gray-50 rounded-lg mt-6 border border-gray-200 flex items-center px-3" data-id="element-210">
                <CreditCard className="w-4 h-4 text-gray-400 mr-2" data-id="element-211" />
                <span className="text-xs text-gray-500 font-mono tracking-widest" data-id="element-212">
                  **** **** **** 4242
                </span>
              </div>
              <div className="h-10 bg-[#0B5FA5] rounded-lg mt-3 flex items-center justify-center shadow-sm" data-id="element-213">
                <span className="text-sm text-white font-medium" data-id="element-214">
                  Pay $100.00
                </span>
              </div>
            </div>
          </div>

          {/* Floating Icons */}
          <div className="absolute top-4 left-8 w-14 h-14 bg-white rounded-xl shadow-xl flex items-center justify-center border border-gray-100 animate-bounce" style={{
          animationDuration: '3s'
        }} data-id="element-215">
            <Monitor className="w-6 h-6 text-[#0B5FA5]" data-id="element-216" />
          </div>
          <div className="absolute bottom-12 left-0 w-16 h-16 bg-white rounded-xl shadow-xl flex items-center justify-center border border-gray-100 animate-bounce" style={{
          animationDuration: '4s',
          animationDelay: '1s'
        }} data-id="element-217">
            <Smartphone className="w-7 h-7 text-[#0B5FA5]" data-id="element-218" />
          </div>
          <div className="absolute -right-6 top-1/2 w-20 h-20 bg-[#F5C400] rounded-full shadow-xl flex items-center justify-center border-4 border-white" data-id="element-219">
            <CreditCard className="w-8 h-8 text-gray-900" data-id="element-220" />
          </div>
        </div>
      </div>
    </section>;
}